import React, {useContext, useState} from 'react';
import {
    _t,
    deleteCookie
  } from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import BellRing from './BellRing';
import { RestaurantContext } from '../../../../contexts/Restaurant';

const BuildModal = ({
    restaurantModal,
    setRestaurantModal,
}) => {
    const { t } = useTranslation();
    const { audioInstance } = useContext(RestaurantContext)

    const [ bellRing, setBellRing] = useState(localStorage.getItem('build-update-bell-ring') || false);

    // handle close modal
    const handleBellRingChange = () => {
        setRestaurantModal(false)
        setBellRing(true);
        localStorage.setItem('build-update-bell-ring', true);
    }

    //handle bell ring change
    const handleBellRingClose = () => {
        setRestaurantModal(false);
        if(audioInstance.current){
            audioInstance.current.pause();
            audioInstance.current.currentTime = 0;
        }
        localStorage.clear();
        deleteCookie();
    }

  return (
    <>
    {/* bell ring animation */}
    <BellRing bellRing={bellRing} handleBellRingClose={handleBellRingClose} type="build"/>
    {/* build update modal issue */}
    {
        restaurantModal && (
            <div
            className={`modal fade ${restaurantModal ? "showing" : ""}`}
            aria-hidden="true"
            >
                <div className="modal-dialog modal-md">
                    <div className="modal-content" style={{ borderRadius: "1rem" }}>
                        <div className="modal-body py-4">
                            <div className="card card-body">
                                <h2 className='text-center'>{_t(t("Hurray! 🎉"))}</h2>
                                <p className="text-center">{_t(t("A new version update is available. Please clear your cache to apply the update."))}</p>
                                <div className="d-flex justify-content-center mb-3 rounded-sm">
                                    <button className="btn btn-success mr-4" onClick={()=>handleBellRingChange()}>
                                        {_t(t("Cancel"))}
                                    </button>
                                    <button
                                        className="btn btn-primary rounded-sm"
                                        onClick={() => {
                                            localStorage.clear();
                                            deleteCookie();
                                            setRestaurantModal(false)
                                        }}
                                    >
                                        {_t(t("Flush Cache"))}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>   
        )
    }
      
    </>
  )
}

export default BuildModal
